// extracted by mini-css-extract-plugin
module.exports = {"SimpleSelect":"simple-select_SimpleSelect__25ij1"};